var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "64 64 896 896",
    focusable: "false",
    "data-icon": "press",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M509.891,863C382.936,863,271.738,795.59,210.1,694.62l69.733-19.853c24.932-7.1,31.519-39.345,11.368-55.652L164.726,516.762A32,32,0,0,0,114.381,531.1l-53.6,153.62c-8.54,24.476,14.044,48.417,38.976,41.319l56.479-16.08c69.61,125.076,203.138,209.7,356.436,209.7,196.339,0,360.251-138.8,398.978-323.634H850.768C813.117,749.3,674.783,863,509.891,863Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M921.73,289.209l-54.953,20.715c-70.234-122.807-202.5-205.576-354.1-205.576-197.046,0-361.438,139.8-399.4,325.634h55.254C205.467,275.7,344.282,161,509.891,161c127.657,0,239.38,68.16,300.8,170.063l-64.162,24.186c-24.257,9.143-28.144,41.825-6.709,56.4l134.535,91.5a32,32,0,0,0,48.981-18.463L964,327.15C970.48,302.049,945.987,280.066,921.73,289.209Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.7dfb816624998147561a318ba299b5fd.svg";
export { ForwardRef as ReactComponent };